import { partnerClient } from '@modules/core/services';
import { EditGoal, EditedGoal } from '../components/CollectionAndSequencing/Overview/SequenceGoal/SequenceGoal.types';
import { DEFAULT_STUDY_ID } from '../constants';
import { editGoalsDefaultValues } from '../hooks/useQueryEditGoals';

const getPath = (id: string): string => {
  return `/studies/${id}/settings/default`;
};

export const fetchGoals = async (studyId = DEFAULT_STUDY_ID): Promise<EditGoal | undefined> => {
  try {
    const response = await partnerClient.get(getPath(studyId));
    return response?.data;
  } catch (err: any) {
    if (err?.response?.status) {
      return editGoalsDefaultValues;
    }
  }
};

export const editGoals = async (data: EditedGoal, studyId = DEFAULT_STUDY_ID): Promise<EditGoal | undefined> => {
  const response = await partnerClient.put(getPath(studyId), data);
  return response?.data;
};
